
import { defineComponent } from 'vue'
import EditSsoJoinRule from '@/components/sso-join-rules/forms/edit-sso-join-rule.vue'
import { useRoute } from 'vue-router'
import { useSSOJoinRulesModule } from '@/modules/sso-join-rules'

export default defineComponent({
    name: 'view-sso-join-rules-edit',
    components: {
        EditSsoJoinRule
    },
    async setup () {
        const { getSSOJoinRule, currentSSOJoinRule } = useSSOJoinRulesModule()
        const route = useRoute()

        const joinRuleId = route.params.id as string
        await getSSOJoinRule(joinRuleId)

        return {
            currentSSOJoinRule
        }
    }
})
